import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=594e1fd2"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('594e1fd2')) {
      api.createRecord('594e1fd2', component.options)
    } else {
      api.reload('594e1fd2', component.options)
    }
    module.hot.accept("./Comment.vue?vue&type=template&id=594e1fd2", function () {
      api.rerender('594e1fd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/Comment.vue"
export default component.exports